import { SvgIconType } from './svg.interface';

const ChevronDown: SvgIconType = ({
  width = 12,
  height = 12,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1935 3.96987C10.4867 3.67671 10.962 3.67671 11.2552 3.96987C11.5483 4.26304 11.5483 4.73835 11.2552 5.03152L6.53035 9.75631C6.23746 10.0492 5.76259 10.0492 5.4697 9.75631L0.744898 5.03152C0.451733 4.73835 0.451733 4.26304 0.744898 3.96987C1.03806 3.67671 1.51338 3.67671 1.80654 3.96987L6.00002 8.16336L10.1935 3.96987Z"
      fill="#4F566B"
    />
  </svg>
);

export default ChevronDown;
